module.exports = __webpack_public_path__ + "img/grand-cancun-pool-3.9e25de23.jpg";